"use client";
import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import Card from "react-bootstrap/Card";
import "@/styles/BlogEntries.scss";
import { useQuery } from "@tanstack/react-query";
import { fetchBlogData } from "@/components/services/QueryDataHelper";

function BlogEntries(props: any) {
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex: number, e:any) => {
    setIndex(selectedIndex);
  };
  const { data, error, isLoading } = useQuery({
    queryKey: ["BLOG-DATA"],
    queryFn: () => fetchBlogData(),
    staleTime: 14400000 //4 hours
  });

  if (!isLoading && data?.entry?.length > 0) {
    let Items = [];

    for (let x = 0; x < data.entry.length; x++) {
      Items.push(
        <Carousel.Item key={data.entry[x].id.$t}>
          <h2>{data.entry[x].title.$t}</h2>
          <div
            dangerouslySetInnerHTML={{ __html: data.entry[x].content.$t }}
          ></div>
        </Carousel.Item>
      );
    }
    if (props.card) {
      return (
        <Card bg={props.bg}>
          <Card.Body>
            <Carousel
              className={props.className}
              controls={props.controls}
              indicators={false}
              activeIndex={index}
              onSelect={handleSelect}
            >
              {Items}
            </Carousel>
          </Card.Body>
        </Card>
      );
    } else {
      return (
        <Carousel
          className={props.className}
          controls={props.controls}
          indicators={false}
          activeIndex={index}
          onSelect={handleSelect}
        >
          {Items}
        </Carousel>
      );
    }
  } else return null;
}

export default BlogEntries;
